<template>
  <section class="upload-platform">
    <header>
      <div class="flow-btn"></div>
      <div class="title">
        <h1>{{ $t('create.platformTitle') }}</h1>
        <p>{{ $t('create.platformSubtitle') }}
          <router-link to="/media/default">{{ $t('create.platformDefaultLink') }}</router-link>
        </p>
      </div>
      <!-- <router-link tag="button">Continue</router-link> -->
      <div class="flow-btn">
        <button @click="nextStep" :disabled="!checkedHMI">{{ $t('buttons.continue') }}</button>
      </div>
    </header>
    <div class="toggle-buttons">
      <toggle-button v-model="checkedHMIUS" label="HMI (US)" @input="checkedHMICA = false"></toggle-button>
      <toggle-button v-model="checkedHMICA" label="HMI (CA)" @input="checkedHMIUS = false"></toggle-button>
      <toggle-button :label="$t('create.platformPortal') + ' (TBD)'" :disabled="true"></toggle-button>
      <toggle-button :label="$t('create.platformMobileApp') + ' (TBD)'" :disabled="true"></toggle-button>
    </div>
  </section>
</template>

<script>
import ToggleButton from '@/components/ToggleButton.vue'
import { SET_PLATFORM, SET_COUNTRY } from '@/store/mutations.type'

export default {
  name: 'upload-platform',
  components: {
    ToggleButton
  },
  data() {
    return {
      checkedHMIUS: false,
      checkedHMICA: false,
    }
  },
  computed: {
    checkedHMI() {
      return this.checkedHMIUS || this.checkedHMICA;
    },
  },
  methods: {
    nextStep() {
      let platform = ''
      if (this.checkedHMI) platform = 'hmi'
      if (this.checkedHMIUS) this.$store.commit(SET_COUNTRY, 'USA');
      else if (this.checkedHMICA) this.$store.commit(SET_COUNTRY, 'CAN');
      this.$store.commit(SET_PLATFORM, platform)
      this.$emit('next', platform)
    }
  }
}
</script>

<style lang="scss" scoped>
.toggle-buttons {
  margin: 30px 0 0 -25px;
}
</style>
